import { render, staticRenderFns } from "./emptyLayout.vue?vue&type=template&id=155a05c3&scoped=true&"
import script from "./emptyLayout.vue?vue&type=script&lang=js&"
export * from "./emptyLayout.vue?vue&type=script&lang=js&"
import style0 from "./emptyLayout.vue?vue&type=style&index=0&id=155a05c3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155a05c3",
  null
  
)

export default component.exports